// Libraries
import { Box } from "@material-ui/core";
import { useObserver } from "mobx-react-lite";
import React from "react";

// Custom
import { EditVariants } from "Custom/StylesAppSpecific/EditVariants";
import { ProductsCommonViewModel } from "Custom/ViewModels/ProductSelector/SubViewModels/GutterSystemSubViewModels/ProductsCommonViewModel";
import { PlygeneMouldedViewModel } from "Custom/ViewModels/ProductSelector/SubViewModels/GutterSystemSubViewModels/PlygeneProductViewModels/PlygeneMouldedViewModel";
import { BQSEditNumber } from "Custom/Views/Primitives/Edits/BQSEditNumber";
import { BQSRow } from "Custom/Views/Primitives/Row/BQSRow";

interface IProps {
    className?: string;
    commonViewModel: ProductsCommonViewModel;
    viewModel: PlygeneMouldedViewModel;
}

export const PlygeneMoulded: React.FC<IProps> = (props: IProps) => {
    // #region Code Behind

    const editVariants = EditVariants();

    // #endregion Code Behind

    // #region Render Result

    return useObserver(() => (
        <Box>
            <BQSRow>
                <BQSEditNumber
                    className={editVariants.bqsEditNumberStandard}
                    displayName="Gutter length"
                    endAdornment="m"
                    execute={props.commonViewModel.setGutterLengthMeterage}
                    minimumValue={0}
                    startAdornment={`<div class="${editVariants.bqsKeyAAdornment}"></div>`}
                    value={props.viewModel.gutterLengthMeterage}
                />
                <BQSEditNumber
                    className={editVariants.bqsEditNumberStandard}
                    displayName="Gutter girth"
                    endAdornment="mm"
                    execute={props.commonViewModel.setGirth}
                    minimumValue={0}
                    startAdornment={`<div class="${editVariants.bqsKeyBAdornment}"></div>`}
                    value={props.viewModel.girth}
                />
            </BQSRow>
        </Box>
    ));

    // #endregion Render Result
};
